import React, { useState } from 'react';
import { Button, DatePicker, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { API_ORIGIN } from '../../../config';

const ExportPanel = () => {
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleExportCSV = async () => {
    if (!dateFrom || !dateTo) {
      message.error('Please select both from and to dates');
      return;
    }

    setLoading(true);
    try {
      const from = dateFrom.format('YYYY-MM-DD');
      const to = dateTo.format('YYYY-MM-DD');

      const response = await fetch(`${API_ORIGIN}/api/excel-direct-order/export?dateFrom=${from}&dateTo=${to}`, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to export CSV');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `direct_orders_${from}_to_${to}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      message.success('CSV exported');
    } catch (error) {
      message.error('Failed to export CSV');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="do-panel">
      <div className="do-setting">
        <div>
          <h2 className="do-panel__title">Date range</h2>
          <p className="do-panel__hint">Every direct order raised between the two dates is included.</p>
        </div>
        <div className="do-setting__fields">
          <div className="do-setting__field">
            <label htmlFor="do-export-from">From</label>
            <DatePicker id="do-export-from" value={dateFrom} onChange={setDateFrom} format="DD/MM/YYYY" />
          </div>
          <div className="do-setting__field">
            <label htmlFor="do-export-to">To</label>
            <DatePicker id="do-export-to" value={dateTo} onChange={setDateTo} format="DD/MM/YYYY" />
          </div>
          <Button type="primary" icon={<DownloadOutlined />} loading={loading} onClick={handleExportCSV}>
            Export CSV
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ExportPanel;
